var _excluded = ["illustration", "gray", "centered", "children", "footer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import AlloyEmptyState from '@adsk/alloy-react-empty-state';
import { Wrapper, Action, Footer } from './styles';

/**
 * EmptyState
 *
 * Composed Alloy component `@adsk/alloy-react-empty-state` with extra props:
 *  1. `footer` to add an extra footer
 *  2. `centered` to center the empty state
 */
var EmptyState = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var illustration = _ref.illustration,
    _ref$gray = _ref.gray,
    gray = _ref$gray === void 0 ? true : _ref$gray,
    _ref$centered = _ref.centered,
    centered = _ref$centered === void 0 ? false : _ref$centered,
    children = _ref.children,
    footer = _ref.footer,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var illustrationType = illustration && gray && !illustration.endsWith('Grey') ? illustration + "Grey" : illustration;
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    "data-testid": "empty-state",
    ref: ref,
    illustrationType: illustrationType
  }, rest, {
    centered: centered
  }), children && /*#__PURE__*/React.createElement(Action, {
    "data-testid": "empty-state-action"
  }, children), footer && /*#__PURE__*/React.createElement(Footer, {
    "data-testid": "empty-state-footer"
  }, footer));
});
EmptyState.displayName = 'EmptyState';
EmptyState.Illustrations = AlloyEmptyState.ILLUSTRATION_TYPES;
EmptyState.propTypes = {
  /** Illustration icon name supported by EmptyState */
  illustration: PropTypes.oneOf(Object.values(AlloyEmptyState.ILLUSTRATION_TYPES)),
  /** Whether hide the default illustration */
  hideIllustration: PropTypes.bool,
  /** Illustration gray mode */
  gray: PropTypes.bool,
  /** The empty state size */
  size: PropTypes.oneOf(Object.values(AlloyEmptyState.SIZES)),
  /** Title of the empty state */
  title: PropTypes.node,
  /** Detail description of the empty state */
  description: PropTypes.node,
  /** Whether to display at the container center. */
  centered: PropTypes.bool,
  /** Detail footer of the empty state */
  footer: PropTypes.node,
  /** The child component */
  children: PropTypes.node
};
export default EmptyState;
//# sourceMappingURL=index.js.map